var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 255,
    viewBox: "0 0 246 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27148_70863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.47 101.36C230.88 101.36 244.18 88.0599 244.18 71.6499C244.18 55.2399 230.88 41.9399 214.47 41.9399C211.26 41.9399 208.18 42.4499 205.29 43.3899",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.65 147.15C42.1618 147.15 46.63 142.682 46.63 137.17C46.63 131.658 42.1618 127.19 36.65 127.19C31.1382 127.19 26.67 131.658 26.67 137.17C26.67 142.682 31.1382 147.15 36.65 147.15Z",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.73 163.11C233.069 163.11 239.83 156.349 239.83 148.01C239.83 139.67 233.069 132.91 224.73 132.91C216.39 132.91 209.63 139.67 209.63 148.01C209.63 156.349 216.39 163.11 224.73 163.11Z",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.81 17.76C117.438 17.76 121.19 14.0081 121.19 9.38C121.19 4.75185 117.438 1 112.81 1C108.182 1 104.43 4.75185 104.43 9.38C104.43 14.0081 108.182 17.76 112.81 17.76Z",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77 56.3799V93.3999",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.29 74.8899H11.26",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.74 213.39V230.43",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.26 221.91H163.21",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.14 137.37C152.38 123.12 143 70.5001 106 76.4999C124 51.0001 85.5001 26.3603 74.33 29.0001C71.5002 29.6689 65.5002 31.4998 66.9999 37.5001L83.22 109.04C85.17 116.13 79.72 129.75 74.33 134.76",
    stroke: "#2A518C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5 48.5001C182.78 34.0201 176.5 26.5001 162 26.5C147.5 26.4999 120 39.5002 114.5 56.0001",
    stroke: "#2A518C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.5 78.9998C133.5 56.9998 173.85 48.2201 184.5 48.0001C193.81 47.8101 203.83 54.7599 197.8 71.2699",
    stroke: "#2A518C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.99 107.55C212.14 98.42 214.33 77.98 205.06 72.96C196.88 68.52 171.89 72.48 151.7 89.58C139.8 99.66 154.55 115.51 154.55 115.51",
    stroke: "#2A518C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.62 172.08C206.16 146.88 213.01 107.98 197.62 105.31C180.82 102.39 153.17 113.2 147.69 124.16C144.31 130.92 146.87 140.37 153.26 144.95C162 149.5 175.75 143.4 186.46 131.35",
    stroke: "#2A518C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.03 148.11L176 141",
    stroke: "#2A518C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.07 179.92C168.07 179.92 173.62 185.2 171.64 187.91C152.13 211.5 71.11 162 68.79 133.39L17.17 194.09",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.64 187.9L136.68 240.83",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.77 186.9C196.22 175.03 207.94 181.84 207.94 181.84",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.02 197.86C195.34 194.11 199.87 200.48 199.87 200.48",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.64 203.45C196.05 216.42 210.39 230.25 207.48 240.39C202.67 257.13 152.63 257.44 95.7199 241.08C38.7999 224.73 -3.44005 197.9 1.36995 181.17C3.36995 174.22 13.1599 170.1 28.0099 168.84",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27148_70863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 245.17,
    height: 254.15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpLight);
export default __webpack_public_path__ + "static/media/ThumbsUpLight.5e0fff40b9e2311ad98f64f9b1809239.svg";
export { ForwardRef as ReactComponent };